import {
    CREATE_YARN_PO_DETAILS_FAILURE,
    CREATE_YARN_PO_DETAILS_REQUEST,
    CREATE_YARN_PO_DETAILS_SUCCESS,
    CREATE_USER_FORM_YARN_PO_DETAILS,
    DELETE_YARN_PO_DETAILS_FAILURE,
    DELETE_YARN_PO_DETAILS_REQUEST,
    DELETE_YARN_PO_DETAILS_SUCCESS,
    FETCH_SINGLE_YARN_PO_DETAILS_FAILURE,
    FETCH_SINGLE_YARN_PO_DETAILS_REQUEST,
    FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS,
    FETCH_YARN_PO_DETAILS_FAILURE,
    FETCH_YARN_PO_DETAILS_REQUEST,
    FETCH_YARN_PO_DETAILS_SUCCESS,
    YARN_PO_DETAILS_USERFORM_RESET,
    UPDATE_YARN_PO_DETAILS_FAILURE,
    UPDATE_YARN_PO_DETAILS_REQUEST,
    UPDATE_YARN_PO_DETAILS_SUCCESS,
    FETCH_YARN_PO_DETAILS_BY_ID_REQUEST,
    FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS,
    FETCH_YARN_PO_DETAILS_BY_ID_FAILURE,
    FETCH_YARN_PO_PREVIOUS_LIST_REQUEST,
    FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS,
    FETCH_YARN_PO_PREVIOUS_LIST_FAILURE,
    YARN_PO_DETAILS_USERFORM_SELECTED_ROWS,
    FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_REQUEST,
    FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_SUCCESS,
    FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_FAILURE,
    UPDATE_YARN_PO_FAILURE,
    UPDATE_YARN_PO_REQUEST,
    UPDATE_YARN_PO_SUCCESS,
    RESET_USERFORM_DATA,
    MILL_NAME_SUCCESS,
    UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_REQUEST,
    UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_FAILURE,
    UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_SUCCESS
} from './yarnPODetails.actionsType';

export const YARN_PO_DETAILS = 'yarnPODetails';

let initialState = {
    loading: false,
    yarnPODetailsById: [],
    yarnPODetails: [],
    groupList: [],
    employeeList: [],
    RoleInTeamList: [],
    previousList: [],
    selectedRows: [],
    userform: {
        fldIsCora: false,
        fldRatePerKG: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldCostPerBag: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        previousFldId: []
    },
    selectedTeamDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    updatedList: [],
    remarks: ''

};

export let yarnPODetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_PO_DETAILS_REQUEST:
        case FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_REQUEST:
        case FETCH_YARN_PO_DETAILS_BY_ID_REQUEST:
        case CREATE_YARN_PO_DETAILS_REQUEST:
        case FETCH_SINGLE_YARN_PO_DETAILS_REQUEST:
        case UPDATE_YARN_PO_DETAILS_REQUEST:
        case DELETE_YARN_PO_DETAILS_REQUEST:
        case FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST:
        case FETCH_YARN_PO_PREVIOUS_LIST_REQUEST:
        case UPDATE_YARN_PO_REQUEST:
        case UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPODetails: updatePayload
            };
        case FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPODetailsById: updatePayload
            };

        case UPDATE_YARN_PO_SUCCESS: {
            return {
                ...state,
                loading: false,
                updatedList: updatePayload
            };
        }
        case MILL_NAME_SUCCESS:
            return {
                ...state,
                millNameList: updatePayload
            }

        case RESET_USERFORM_DATA:
            return {
                ...state,
                userform: {
                    fldIsCora: false,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldCostPerBag: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
            }

        case CREATE_YARN_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: [],
                userform: {
                    fldIsCora: false,
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                }
            };
        case FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: { ...updatePayload, fldSPRate: updatePayload.fldSPRate },
                userform: { ...updatePayload, fldSPRate: updatePayload.fldSPRate, fldRateDiff: Number(updatePayload.fldSPRate) - Number(updatePayload.fldFKRatePerKG) }
            };
        case UPDATE_YARN_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsCora: false,
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                }
            };
        case DELETE_YARN_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsCora: false,
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
                selectedTeamDetails: {}
            };
        case FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case YARN_PO_DETAILS_USERFORM_SELECTED_ROWS:
            return {
                ...state,
                loading: false,
                selectedRows: payload
            };
        case UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                remarks: updatePayload
            };
        case FETCH_YARN_PO_DETAILS_FAILURE:
        case FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_FAILURE:
        case FETCH_SINGLE_YARN_PO_DETAILS_FAILURE:
        case CREATE_YARN_PO_DETAILS_FAILURE:
        case UPDATE_YARN_PO_DETAILS_FAILURE:
        case DELETE_YARN_PO_DETAILS_FAILURE:
        case FETCH_YARN_PO_DETAILS_BY_ID_FAILURE:
        case FETCH_YARN_PO_PREVIOUS_LIST_FAILURE:
        case UPDATE_YARN_PO_FAILURE:
        case UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_PO_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case YARN_PO_DETAILS_USERFORM_RESET:
            return {
                ...state,
                previousList: [],
                updatedList: [],
                userform: {
                    fldIsCora: false,
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                }
            };
        default:
            return state;
    }
};
